module.exports = __webpack_public_path__ + "static/media/比赛4.779245de.png";